import { render, staticRenderFns } from "./HeroesList.vue?vue&type=template&id=56268188&scoped=true&"
import script from "./HeroesList.vue?vue&type=script&lang=js&"
export * from "./HeroesList.vue?vue&type=script&lang=js&"
import style0 from "./HeroesList.vue?vue&type=style&index=0&id=56268188&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56268188",
  null
  
)

export default component.exports